<template>
  <div id="center">
    <div class="up">
      <div
        class="item"
        v-for="item in titleItem"
        :key="item.title"
      >
        <dv-border-box-12 style="height: 100px">
        <div class="titleDiv" style="padding: 10px">
        <el-tag class="tileSize">{{ item.title }}</el-tag>
        </div>
          <div>
          <dv-digital-flop
            class="dv-dig-flop mt-2"
            :config="item.number"
          />
        </div>
        </dv-border-box-12>
      </div>
    </div>
    <div class="down">
      <dv-scroll-board style="height: 260px" :config="customerConfig"  />
    </div>
  </div>
</template>

<script>
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companyData",
  mixins: [autoResize],
  data() {
    return {
      customerConfig: {
        header: ["<h3>客户名称</h3>", "<h3>所在地区</h3>"],
        data: [
          ["<h3>上海康久消毒技术股份有限公司</h3>", "<h3>上海</h3>" ],
          ["<h3>七个蛋白盐城智能科技有限公司</h3>", "<h3>盐城</h3>" ],
          ["<h3>1个蛋白盐城智能科技有限公司</h3>", "<h3>江苏</h3>" ],
          ["<h3>2个蛋白盐城智能科技有限公司</h3>",  "<h3>杭州</h3>"],
          ["<h3>3个蛋白盐城智能科技有限公司</h3>",  "<h3>重庆</h3>"],
          ["<h3>4个蛋白盐城智能科技有限公司</h3>",  "<h3>山东</h3>"],
          ["<h3>5个蛋白盐城智能科技有限公司</h3>", "<h3>上海</h3>"],
          ["<h3>6个蛋白盐城智能科技有限公司</h3>",  "<h3>上海</h3>"],
        ],
        rowNum: 7, //表格行数
        headerHeight: 45,
        index: false,
        columnWidth: [500, 250],
        align: ['center', 'center'],
      },
      titleItem: [
        {
          title: '服务客户',
          number: {
            number: [35126],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}家',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '业务分布',
          number: {
            number: [18],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}个省市',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '行业分布',
          number: {
            number: [16],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}个',
            style: {
              fontSize: 26
            }
          }
        },
      ]
    }
  },
  watch: {

  },
  components: {
  },
  methods: {
    formatter (number) {
      const numbers = number.toString().split('').reverse()
      const segs = []

      while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

      return segs.join(',').split('').reverse().join('')
    }
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 20%;
    .titleDiv {
      width: 100%;
      align-items: center;
      display: flex;
      .tileSize {
        color: rgb(0, 186, 255);
        font-size: 20px;
        text-align: center;
        width:90%;
        margin: 0 auto
      }
    }
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      .dv-dig-flop {
        width: 100%;
        height: 30px;
      }

    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 80%;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 59%;
      .dv-scr-rank-board {
        height: 225px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          width: 100%;
          height: 120px;
          text-align: center;
        }
      }
    }
  }
}
</style>
